import { useState, useCallback, useRef } from 'react'
import { Servicio } from '../services/apiService'
import { readStream } from '../helpers/streamParser'

export interface Message {
  id: string
  text: string
  sender: 'user' | 'bot'
  timestamp: Date
}

const api = new Servicio()

export function useStreamChat() {
  const [messages, setMessages] = useState<Message[]>([])
  const [isStreaming, setIsStreaming] = useState(false)
  const abortRef = useRef<AbortController | null>(null)

  const sendMessage = useCallback(async (prompt: string, token: string, userId: number, userName: string) => {
    const userMsg: Message = { id: Date.now().toString(), text: prompt, sender: 'user', timestamp: new Date() }
    const botId = (Date.now() + 1).toString()

    setMessages(prev => [...prev, userMsg, { id: botId, text: '', sender: 'bot', timestamp: new Date() }])
    setIsStreaming(true)

    try {
      const res = await api.streamApi('/stream', token, { prompt, user_id: userId, name_user: userName, mode: "text" })

      await readStream(
        res,
        (chunk) => setMessages(prev => prev.map(m => m.id === botId ? { ...m, text: m.text + chunk } : m)),
        () => setIsStreaming(false),
        (error) => {
          setMessages(prev => prev.map(m => m.id === botId ? { ...m, text: `Error: ${error}` } : m))
          setIsStreaming(false)
        }
      )
    } catch {
      setMessages(prev => prev.map(m => m.id === botId ? { ...m, text: 'Error de conexión con el servidor' } : m))
      setIsStreaming(false)
    }
  }, [])

  const clearMessages = useCallback(() => setMessages([]), [])

  return { messages, isStreaming, sendMessage, clearMessages }
}
